import { FC, HTMLAttributes } from "react";
import classNames from "classnames";
import st from "./Label.module.scss"; 

interface ILabelProps extends HTMLAttributes<HTMLLabelElement> {
	/** ИД контрола к которому будем привязываться */
	htmlFor?: string;
	/** Обязательно ли для заполнения */
	required?: boolean;
	/** Расположение звездочки относительно заголовка */
	placeAsterix?: "before" | "after"
};

/** Компонента отображающая заголовок поля */
const Label: FC<ILabelProps> = ( { htmlFor, required = false, placeAsterix = "after", children, className, ...otherProps } ) => {

	const req = required ? ( placeAsterix === "after" ? st.required_after : st.required_before ) : "";
	const classes = classNames( st.label, className, req );

	return (
		<label className={classes} {...otherProps} >
			{ children }
		</label>
	);
};

export default Label;
